import React from 'react';
import Select from '../../../components/ui/Select';

const EventFilters = ({ filters, onFilterChange, projects, contractors, teamMembers }) => {
  const handleFilterChange = (name, value) => {
    onFilterChange?.({ ...filters, [name]: value });
  };

  const eventTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'availability', label: 'Team Availability' },
    { value: 'booking', label: 'Contractor Bookings' },
    { value: 'milestone', label: 'Project Milestones' },
    { value: 'inspection', label: 'Permit Inspections' }
  ];

  const projectOptions = [
    { value: 'all', label: 'All Projects' },
    ...(projects?.map(project => ({
      value: project?.id,
      label: project?.customerName || project?.address || 'Unknown Project'
    })) || [])
  ];

  const contractorOptions = [
    { value: 'all', label: 'All Contractors' },
    ...(contractors?.map(contractor => ({
      value: contractor?.id,
      label: contractor?.name || 'Unknown Contractor'
    })) || [])
  ];

  const teamMemberOptions = [
    { value: 'all', label: 'All Team Members' },
    ...(teamMembers?.map(member => ({
      value: member?.id,
      label: member?.fullName || member?.email || 'Unknown Member'
    })) || [])
  ];

  return (
    <div className="bg-card rounded-xl shadow-sm border border-border p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="Event Type"
          options={eventTypeOptions}
          value={filters?.eventType}
          onChange={(val) => handleFilterChange('eventType', val)}
        />

        <Select
          label="Project"
          options={projectOptions}
          value={filters?.projectId}
          onChange={(val) => handleFilterChange('projectId', val)}
        />

        <Select
          label="Contractor"
          options={contractorOptions}
          value={filters?.contractorId}
          onChange={(val) => handleFilterChange('contractorId', val)}
        />

        <Select
          label="Team Member"
          options={teamMemberOptions}
          value={filters?.teamMemberId}
          onChange={(val) => handleFilterChange('teamMemberId', val)}
        />
      </div>
    </div>
  );
};

export default EventFilters;